import React, { MouseEvent, useState } from 'react'
import LocationList from '@/resources/LocationList.json'
import RegionList from '@/resources/RegionList.json'
import OverWorldModal from '@/views/OverWorldModal'

type Props = {
  selectedRegion: number
  partsStates: {
    index: number
    name: string
    question: string
    state: number
    setState: (value: number) => void
  }[]
}

const ImageView = ({ selectedRegion, partsStates }: Props) => {
  // #region フック

  const [isOpen, setIsOpen] = useState<boolean>(false)
  const [currentMapCode, setCurrentMapCode] = useState<number>(-1)

  // #endregion フック

  // #region スタイル

  const imagesStyle: React.CSSProperties = {
    width: '185px',
    marginLeft: '6px',
    marginTop: '6px'
  }

  const imageInfoStyle: React.CSSProperties = {
    textAlign: 'center',
    fontSize: '14px',
    lineHeight: '0px'
  }

  // #endregion スタイル

  // #region イベント

  const onClickImage = (e: MouseEvent<HTMLDivElement>) => {
    const id = parseInt(e.currentTarget.id.replace('map-image-', ''))
    setCurrentMapCode(id)
    setIsOpen(true)
  }

  const closeModal = () => {
    setIsOpen(false)
  }

  // #endregion イベント

  const displayImages = LocationList['grotto-locations'].map((s) => {
    if (selectedRegion !== 0 && RegionList.regions[selectedRegion - 1] !== s['region-name']) {
      return <React.Fragment key={`map-image-${s.code}`}></React.Fragment>
    }
    if (partsStates[0].state !== 2 && partsStates[0].state !== s.water) {
      return <React.Fragment key={`map-image-${s.code}`}></React.Fragment>
    }
    if (partsStates[1].state !== 2 && partsStates[1].state !== s.mountain) {
      return <React.Fragment key={`map-image-${s.code}`}></React.Fragment>
    }
    if (partsStates[2].state !== 2 && partsStates[2].state !== s.tree) {
      return <React.Fragment key={`map-image-${s.code}`}></React.Fragment>
    }
    if (partsStates[3].state !== 2 && partsStates[3].state !== s.road) {
      return <React.Fragment key={`map-image-${s.code}`}></React.Fragment>
    }
    if (partsStates[4].state !== 2 && partsStates[4].state !== s.ramp) {
      return <React.Fragment key={`map-image-${s.code}`}></React.Fragment>
    }
    if (partsStates[5].state !== 2 && partsStates[5].state !== s.bridge) {
      return <React.Fragment key={`map-image-${s.code}`}></React.Fragment>
    }
    if (partsStates[6].state !== 2 && partsStates[6].state !== s['bulletin-board']) {
      return <React.Fragment key={`map-image-${s.code}`}></React.Fragment>
    }
    if (partsStates[7].state !== 2 && partsStates[7].state !== s.ford) {
      return <React.Fragment key={`map-image-${s.code}`}></React.Fragment>
    }
    if (partsStates[8].state !== 2 && partsStates[8].state !== s['poison-swamp']) {
      return <React.Fragment key={`map-image-${s.code}`}></React.Fragment>
    }
    if (partsStates[9].state !== 2 && partsStates[9].state !== s['dead-tree']) {
      return <React.Fragment key={`map-image-${s.code}`}></React.Fragment>
    }
    return (
      <div key={s.code} className='map-images' id={`map-image-${s.code}`} onClick={onClickImage}>
        <img style={imagesStyle} src={`images/${String(s.code).padStart(3, '0')}.png`} />
        <p style={imageInfoStyle}>
          {`0x${s.code.toString(16).toUpperCase().padStart(2, '0')}`}&ensp;
          {`${s['region-name']}`}
        </p>
      </div>
    )
  })

  return (
    <>
      {displayImages}
      <OverWorldModal isOpen={isOpen} mapCode={currentMapCode} closeModal={closeModal} />
    </>
  )
}

export default ImageView
